var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('UserGroups'),_c('HrPermissionsSelector',{ref:"permissionsSelector"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }